<template>
	<div class="flex items-center gap-x-2" :class="[]">
		<span class="leading-none">{{ ratings }}</span>
		<slot v-for="ratingIndex in maxRatings" name="icon">
			<IconStar :percentage="percentage(ratingIndex)"></IconStar>
		</slot>
	</div>
</template>

<script setup>
import IconStar from '@/components/icons/IconStar.vue'

const props = defineProps({
	maxRatings: {
		type: Number,
		default: 5,
		required: false,
	},
	ratings: {
		type: Number,
		default: 3,
		required: false,
	},
	iconWidth: {
		type: String,
		required: false,
		default: '',
	},
	iconHeight: {
		type: String,
		required: false,
		default: '',
	},
})

const percentage = (ratingIndex) => {
	if (Math.floor(props.ratings) >= parseInt(ratingIndex, 10)) {
		return 100
	}

	if (ratingIndex === Math.ceil(props.ratings)) {
		return (props.ratings - Math.floor(props.ratings)) * 100
	}

	return 0
}
</script>
